module.exports = __webpack_public_path__ + "img/news-inner-image-left.0e9a2efd.jpg";